import {
    Grid2, Typography,
} from "@mui/material";
import { TicketTypeEnum } from "../../../_common/enum/ticketType.enum";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { getFormatedDate } from "../../../_helpers/dateTime.helper";

export function TicketSubjectData(params: { subjectData?: any, ticketType: TicketTypeEnum }) {
    const { subjectData, ticketType } = params;

    const isHidden =
        ticketType === TicketTypeEnum.Serve;

    const getAddressHeader = () => {
        switch (ticketType) {
            case TicketTypeEnum.Serve:
            case TicketTypeEnum.OccupancyCheck:
                return "Address";
            case TicketTypeEnum.FullTraceEnquiries:
            case TicketTypeEnum.DesktopTrace:
            case TicketTypeEnum.FieldAgentEnquiries:
                return "Last Known Address (if applicable)";
            case TicketTypeEnum.StatusReport:
                return "Known Address";
            case TicketTypeEnum.GeneralEnquiries:
                return "Address (if applicable)";
            default:
                return "Address";
        }
    };

    //Might need this later to update teh Subject Address directlly from the ticket
    //function handleChange(event: any) {
    //    setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    //}

    //const handleAddressChange = (event: any) => {
    //    setData((_data: any) => ({
    //        ..._data, address:
    //        {
    //            ..._data.address, [event.target.name]: event.target.value
    //        }
    //    }));
    //};

    return (
        <Grid2 container spacing={2}>

            {/* Label Row (for visual alignment of Subject Name and Address heading) */}
            {!isHidden && (
                <Grid2 size={{ xs: 12 }}>
                    <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>{getAddressHeader()}</Typography>
                </Grid2>
            )}

            {/* Main Form Row */}
            <Grid2 container spacing={2}>
                {/* Left column */}
                {!isHidden && (
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Grid2 container spacing={1.5}>
                            <Grid2 size={{ xs: 12 }}>
                                <StandardTextValidator
                                    key="name"
                                    name="name"
                                    fullWidth
                                    value={subjectData?.name}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12 }}>
                                <StandardTextValidator
                                    key="dateOfBirth"
                                    name="dateOfBirth"
                                    label="Date Of Birth"
                                    type="date"
                                    fullWidth
                                    value={subjectData?.dateOfBirth != null ? getFormatedDate(subjectData?.dateOfBirth) : ""}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12 }}>
                                <StandardTextValidator
                                    name="phone"
                                    label="Phone"
                                    fullWidth
                                    validators={['matchRegexp:^\\+?[0-9]{7,15}$']}
                                    errorMessages={['Enter a valid phone number (7-15 digits, optional +)']}
                                    value={subjectData?.phone}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12 }}>
                                <StandardTextValidator
                                    key="other"
                                    name="other"
                                    label="Other"
                                    fullWidth
                                    value={subjectData?.other}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                )}

                {/* Right column */}
                <Grid2 size={{ xs: 12, md: isHidden ? 12 : 6 }}>
                    <Grid2 container spacing={1.5}>
                        {isHidden && (
                            <Grid2 size={{ xs: 12 }}>
                                <Typography variant="subtitle1">{getAddressHeader()}</Typography>
                            </Grid2>
                        )}

                        {isHidden && (
                            <Grid2 size={{ xs: 12 }}>
                                <StandardTextValidator
                                    key="name"
                                    name="name"
                                    label="Subject Name"
                                    fullWidth
                                    value={subjectData?.name}
                                />
                            </Grid2>
                        )}

                        <Grid2 size={{ xs: 12 }}>
                            <StandardTextValidator
                                key="addressLine1"
                                name="addressLine1"
                                label="Address Line 1"
                                fullWidth
                                value={subjectData?.address?.addressLine1}
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <StandardTextValidator
                                key="addressLine2"
                                name="addressLine2"
                                label="Address Line 2"
                                fullWidth
                                value={subjectData?.address?.addressLine2}
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <StandardTextValidator
                                key="city"
                                name="city"
                                label="Town/City"
                                fullWidth
                                value={subjectData?.address?.city}
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <StandardTextValidator
                                key="eirCode"
                                name="eirCode"
                                label="EirCode/PostCode"
                                fullWidth
                                value={subjectData?.address?.eirCode}
                            />
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
        </Grid2>
    );
}